import React from 'react';
import DatePicker from 'react-datepicker';
import {Text} from '../Text';

export default function DateInput(props) {
  return (
    <div style={{position:'relative', ...props.style}}>
      <Text bold block small style={{marginBottom:4}}>
        {props.label}
      </Text>
      <DatePicker
        selected={props.value}
        onChange={props.onChange}
        customInput={
          <input 
            style={{
              boxSizing: 'border-box',
              display: 'block',
              width: '100%',
              padding: '8px',
              fontFamily: 'MontserratLight',
              fontSize: 20, 
              color: '#243746',
              lineHeight: '32px',
              backgroundColor: '#ffffff',
              border: 0,
              boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
            }}
          />
        }
      />
      <svg style={{position:'absolute', top:32, right:8, fill:'#aaaaaa', pointerEvents:'none'}} width="24" height="24" viewBox="0 0 24 24">
        <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </div>
  );
}